import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";

import makeStyles from '@mui/styles/makeStyles';

import { cellFocusEditor, dateEditor } from "../services/Common";
import PropTypes from "prop-types";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  RadioGroup,
  MenuItem,
  Paper,
  CardHeader,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};



const ProductSelectInPrescriptionModal = ({ handleClose, open, addProductBatch, formulation,pselectedPrescriptionItem, ...props }) => {
  
  const { t, i18n } = useTranslation();
  //get DispensingLanguage
  const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
  const lan = localStorage.getItem('LangCode');
  const menukey = "prescriptions";
  const [ProdustDataItems, setProdustDataItemst] = useState([]);
  const [selectedProducts, setselectedProducts] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [requiredPcks, setRequiredPcks] = useState(0);
  
  const tblRefHolder = useRef({ table: null });
  const tblRef = tblRefHolder.current;
  
  const { isLoading, error, isError, data, refetch } = useQuery(
    ["ProductSelectInPrescriptionModal", formulation],
    api.getProductSelectInPrescriptionModal,{
      onSuccess: (data) => {


   
        
        let ProdustDataItems = data?.map((item, index) => {
          console.log('item mmmmmmmmm: ', item);
          // console.log(item);
      
          console.log('pselectedPrescriptionItem mmmmmmmmmm: ', pselectedPrescriptionItem);
          if(pselectedPrescriptionItem.BatchInfo != null){
                const LinkPcks = pselectedPrescriptionItem.BatchInfo?.filter((obj, i) => {
                  let Pcks = "";
                  if(item.BatchNo == obj.Batch && item.ExpiryDate == obj.ExpiryDate && item.SourceId == obj.SourceId){
                    Pcks = obj.Pcks;
                  }
                  // console.log(obj.Batch);
                  // console.log(obj.ExpiryDate);
                  // console.log(obj.SourceId);
                  return Pcks;
                });
      
              console.log('LinkPcks mmmmmmmmm: ', LinkPcks);
              if(LinkPcks.length>0){
                  item.Pcks = LinkPcks[0].Pcks;
              }else{
                item.Pcks = null;
              }
              console.log('itemssssssssss: ', item);
      
            }else{
              item.Pcks = null;
            }
      
          return item;
        });


        setErrorMessage("");
        console.log('ProdustDataItemssssssss: ', ProdustDataItems);
        // let totalRequiredPcks = Math.ceil(pselectedPrescriptionItem.calc / batchList[0].PacksizeName);// all row packsizename are same
        // console.log('totalRequiredPcks: ', totalRequiredPcks);
    
        // setRequiredPcks(totalRequiredPcks);


        setProdustDataItemst(ProdustDataItems);









        // console.log("fetch data by api call");
      },
      refetchOnWindowFocus: false,
      // enabled: false // turned off by default, manual refetch is needed
    }
  );


  // const {error,isError, data, refetch: fetchPatientsForPrescription, } = useQuery(
  //   ["patients", prescriptionFilter],
  //   () => api.getPatientsForPrescription(prescriptionFilter),
  //   {
  //     onSuccess: (data) => {
  //       setLoadingPatient(false);
  //     },
  //     refetchOnWindowFocus: false,
  //     enabled: false, // turned off by default, manual refetch is needed
  //   }
  //   // { enabled: showPatientList }
  // );


  const ProductColumns = [
    { title: "id", field: "ItemNo", visible: false },
    { title: "ItemNo", field: "ItemNo", visible: false },

    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:40, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Product Code']), visible:false, field: "ItemCode", width: 135, headerFilter:true },
    { title: t(DispensingLanguage[lan][menukey]['Product Name']), field: "ItemName", headerFilter:true  },
    {
      title: t(DispensingLanguage[lan][menukey]['Lot Qty']),
      field: "CurrentStockQty",
      width: 90,
      hozAlign: "right",
      headerHozAlign: "right",
       
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Batch#']),
      field: "BatchNo",
      width: 90,
      
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Expiry Date']),
      field: "ExpiryDate",
      width: 90 
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Source']),
      field: "SourceName",
      width: 80 
    },
    {
      title: t(DispensingLanguage[lan][menukey]['Unit Price (CFA)']),
      field: "UnitPrice",
      visible:false,
      width: 100,
      hozAlign: "right",
      headerHozAlign: "right",
       
    } ,{
      title: "SourceId",
      field: "SourceId",
      visible: false
    }, {
      title: t(DispensingLanguage[lan][menukey]["Pcks"]),
      field: "Pcks",
      width: 70,
      hozAlign: "right",
      headerHozAlign: "right",
      headerSort: false,
      validator: ["integer", "min:0"],
      cssClass: "tabluator-column-editable",
      editor: cellFocusEditor,
      cellEdited: function (cell) {
        // const curcellval = cell.getValue();
        // const currow = cell.getRow();
        // const curcol = cell.getField();
        // const rowdata = currow.getData();

       // setUpdatedDetailsGridDataHandler(rowdata, curcol);
      },
      // formatter: reactFormatter(
      //   <RowInputData labelName="Qty" field="qty" fieldType="text" />
      // ),
    }
    ,{
      title: "ProductTypeId",
      field: "ProductTypeId",
      visible: false
    }
  ];

  let selected = [];
  // const ProdustDataItems = data?.map((item, index) => {
  //   console.log('item mmmmmmmmm: ', item);
  //   // console.log(item);

  //   console.log('pselectedPrescriptionItem mmmmmmmmmm: ', pselectedPrescriptionItem);
  //   if(pselectedPrescriptionItem.BatchInfo != null){
  //         const LinkPcks = pselectedPrescriptionItem.BatchInfo?.filter((obj, i) => {
  //           let Pcks = "";
  //           if(item.BatchNo == obj.Batch && item.ExpiryDate == obj.ExpiryDate && item.SourceId == obj.SourceId){
  //             Pcks = obj.Pcks;
  //           }
  //           // console.log(obj.Batch);
  //           // console.log(obj.ExpiryDate);
  //           // console.log(obj.SourceId);
  //           return Pcks;
  //         });

  //       console.log('LinkPcks mmmmmmmmm: ', LinkPcks);
  //       if(LinkPcks.length>0){
  //           item.Pcks = LinkPcks[0].Pcks;
  //       }else{
  //         item.Pcks = null;
  //       }
  //       console.log('itemssssssssss: ', item);

  //     }else{
  //       item.Pcks = null;
  //     }

  //   return item;
  // });

  let selectedRows = [];

  const SaveSelectedProducts = () => {

    console.log('pselectedPrescriptionItem mmmmm111111111111: ', pselectedPrescriptionItem);
    
    let batchList = tblRef.table.getData();
    console.log('batchList mmmmm: ', batchList);

    if(batchList.length == 0){
      return;
    }

    let totalRequiredPcks = Math.ceil(pselectedPrescriptionItem.calc / batchList[0].PacksizeName);// all row packsizename are same
    console.log('pselectedPrescriptionItem.calc: ', pselectedPrescriptionItem.calc);
    console.log('totalRequiredPcks: ', totalRequiredPcks);
    // let totalRequiredPcks = 0;
 

    let tmpTotalPcks = 0;
    let qtyBatchList = [];
    let isLessStock = "";
    let tmpTotalQty = 0;
    batchList.forEach(element => {
      console.log('element: ', element);
      
      if(element.Pcks>0){
        tmpTotalPcks+=parseInt(element.Pcks);
        console.log('element yyeeeesssssss: ', element);

        tmpTotalQty += parseInt(element.Pcks) * element.PacksizeName;

        qtyBatchList.push(element);

        if(element.CurrentStockQty<element.Pcks){
          isLessStock = element.BatchNo;
        }

      }
      
    });

    console.log('tmpTotalQty: ', tmpTotalQty);
    
    console.log('qtyBatchList: ', qtyBatchList);
    console.log('tmpTotalPcks: ', tmpTotalPcks);

    if(qtyBatchList.length == 0){
      setErrorMessage( t(DispensingLanguage[lan][menukey]["Enter Pcks"]));
    }
    else if(isLessStock !== ""){
      setErrorMessage( t(DispensingLanguage[lan][menukey]["Pcks more than Lot Qty"]) + (isLessStock==null?"":" - " + isLessStock));
    }
    else if(tmpTotalQty < pselectedPrescriptionItem.calc){
      setErrorMessage( t(DispensingLanguage[lan][menukey]["Pcks less than msg"])+" "+totalRequiredPcks);
    }
    // else if(tmpTotalPcks < totalRequiredPcks){
    //   setErrorMessage( t(DispensingLanguage[lan][menukey]["Pcks less than msg"])+" "+totalRequiredPcks);
    // }
    else{
        setselectedProducts(qtyBatchList);
        setErrorMessage("");
    }

    // console.log('tblRef.table: ', tblRef.table);
    // console.log('tblRef.table getData: ', tblRef.table.getData());
    // console.log('tblRef.table getSelectedData: ', tblRef.table.getSelectedData());
    

    // if(tblRef.table.getSelectedData().length>0)
    // setselectedProducts(tblRef.table.getSelectedData());
  };



  useEffect(() => {
    addProductBatch(selectedProducts);

    //======early expiry alert message==========
    selectedRows = selectedProducts;
    checkExpiringBatches();
    //======early expiry alert message==========

}, [selectedProducts]);


const checkExpiringBatches = () => {
   
  let count = 0;
  //console.log("ProdustDataItems >>>>>>  ", ProdustDataItems);
  //console.log("selectedRows >>>>>>  ", selectedRows);
  // removing current selected rows
   let rowsWithoutSelected = ProdustDataItems.filter((o) => {
    for (var i = 0; i < selectedRows.length; i++) {
      if (
        selectedRows[i].ItemCode === o.ItemCode &&
        selectedRows[i].ExpiryDate === o.ExpiryDate
      ) {
        return false;
      }
    }
    return true;
  });

 //console.log("removing current selected rows", rowsWithoutSelected);
 //console.log("props ManyTableData >>>>>>>>>>>>>> ", pselectedPrescriptionItem);


  // removing already selected rows in many grid
  if (pselectedPrescriptionItem) {
    rowsWithoutSelected = rowsWithoutSelected.filter((o) => {
      for (var i = 0; i < pselectedPrescriptionItem.length; i++) {
        if (
          pselectedPrescriptionItem[i].ItemCode === o.ItemCode &&
          pselectedPrescriptionItem[i].ExpiryDate === o.ExpiryDate
        ) {
          return false;
        }
      }
      return true;
    });
  }

  //console.log("rowsWithoutSelected: ", rowsWithoutSelected);


  rowsWithoutSelected.forEach((p) => {
    const expiringProds = selectedRows.filter((o) => {
      //console.log("o.ExpiryDate== ", o.ItemCode, "====", o.ExpiryDate);
      if (o.ItemCode === p.ItemCode) {

        if (new Date(o.ExpiryDate, "DD/MM/YYYY") > new Date(p.ExpiryDate, "DD/MM/YYYY")) {
          return true;
        }
      } else {
        return false;
      }
    });

    //console.log("Expiring products: ", expiringProds);

    if (expiringProds.length > 0) {
      count++;
    }
  });

  

   if (count > 0) {
    props.openNoticeModal({
      isOpen: true,
      msg: t(DispensingLanguage[lan][menukey]['Some of your product batches expiring before your selected ones, please select batches which will expire early.']),
      msgtype: 0,
      duration: 10000,
    });
    return;
  } 


}; 




// useEffect(() => {

//   console.log('ProdustDataItems useEffect: ', ProdustDataItems);
//   if(ProdustDataItems.length>0){
//     let totalRequiredPcks = Math.ceil(pselectedPrescriptionItem.calc / ProdustDataItems[0].PacksizeName);// all row packsizename are same
//     console.log('totalRequiredPcks: ', totalRequiredPcks);
//     setRequiredPcks(totalRequiredPcks);
//   }else{
//     setRequiredPcks(0);
//   }

// }, [pselectedPrescriptionItem, ProdustDataItems]); 



  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('ProductBatch')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('ProductBatch')}
        >
        {t(DispensingLanguage[lan][menukey]['Products Lot'])} 
        </BootstrapDialogTitle>

        <DialogContent dividers>
          {/* <Typography
              variant="body2"
              component="p"
              className="sw_text_label"
            >
              { "Prescription item required pcks: " + requiredPcks }
            </Typography> */}

         <ReactTabulator
            onRef={(r) => { tblRef.table = r.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: true,
            }}
            columns={ProductColumns}
            data={ProdustDataItems}
            height="300px"
            layout={"fitColumns"}

          />

        </DialogContent>
        <DialogActions>

          <Typography
              variant="body2"
              component="p"
              className="sw_text_label text-danger"
            >
              {  errorMessage }
            </Typography>

          <Button
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
           {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('ProductBatch')}
          >
            {t(DispensingLanguage[lan][menukey]['Cancel'])}  
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ProductSelectInPrescriptionModal;
